import React from 'react'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { CustomIconButton } from '../../shared/utils/IconButton';
import { Box, Grid2 } from '@mui/material';
import { Form_Padding } from '../../shared/constants';
import { Field, Form, Formik } from 'formik';
import { TextFormField } from '../../shared/components/formfields/TextFormField';
import * as Yup from 'yup';
import { isValidPhoneNumber } from 'react-phone-number-input';
import { useGetUserDetail } from '../../assets/api/UseStudentGetApi';
import { LocationSelectorField } from '../../shared/components/LocationSelectorField';


const ApartmentForm = ({ onClose }) => {
    const { data: userDetail } = useGetUserDetail()
    const validationSchema = Yup.object().shape({
        apartment_name: Yup.string().required('Apartment name is required'),
        contact_person_detail: Yup.string(),
        phonenumber: Yup.string().test("is-phone", "Invalid phone number", function (value) {
            return value ? isValidPhoneNumber(value) : false;
        }),
        email: Yup.string()
            .required('Email is required')
            .email('Invalid email address'),
        designation: Yup.string(),
        flat: Yup.number()
            .typeError('Must be a number')
            .required('Total number of flat is required')
            .positive('Must be a positive number'),
        pincode: Yup.number()
            .typeError('Must be a number')
            .required('Pin code is required'),
        address: Yup.string().required('Address is required'),
        state: Yup.string().required('State is required'),
        city: Yup.string().required('City is required'),

    });

    const initialValues = {
        apartment_name: userDetail?.data?.apartment_name || '',
        pincode: userDetail?.data?.pincode || '',
        country_name: userDetail?.data?.country_name || "",
        state: userDetail?.data?.state || "",
        city: userDetail?.data?.city || "",
        firstname: userDetail?.data?.firstname || "",
        lastname: userDetail?.data?.lastname || "",
        email: userDetail?.data?.email || "",
        mobile: userDetail?.data?.mobile || "",
        address: userDetail?.data?.address || "",

    };

    const handleSubmit = (values) => { };

    return (
        <Box>

            <Box sx={{ p: Form_Padding, bgcolor: "blue.main", position: "relative", minBlockSize: "50px" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <CustomIconButton icon={<KeyboardBackspaceIcon style={{ color: "#fff" }} fontSize='26px' />} onClick={onClose} />
                </Box>
                {/* <Box
                    sx={{
                        position: "absolute",
                        bottom: "-50px",
                        left: "50%",
                        transform: "translateX(-50%)",
                    }}
                >
                    <Avatar
                        src={Constants.customImages.StudentPic}
                        alt="Profile"
                        sx={{
                            width: { lg: "80px", sm: "80px", xs: "50px" },
                            height: { lg: "80px", sm: "80px", xs: "50px" },
                            border: "8px solid #fff",
                        }}
                    />
                </Box> */}


            </Box>

            <Box sx={{ p: Form_Padding, mt: "40px" }}>
                <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
                    {() => (
                        <Form>
                            <Grid2 container spacing={3} >
                                <Grid2 children size={{ sm: 6, xs: 12 }}>
                                    <Field
                                        name="apartment_name"
                                        component={TextFormField}
                                        label="Apartment Name"
                                        isRequired={true}
                                    />
                                </Grid2>
                                <Grid2 children size={{ sm: 6, xs: 12 }}>
                                    <Field
                                        name="firstname"
                                        component={TextFormField}
                                        label="Trainer Name"
                                        isRequired={true}
                                    />
                                </Grid2>
                                <Grid2 children size={{ sm: 6, xs: 12 }}>
                                    <Field
                                        name="lastname"
                                        component={TextFormField}
                                        label="Last Name"
                                        isRequired={false}
                                    />
                                </Grid2>

                                <Grid2 children size={{ sm: 6, xs: 12 }}>
                                    <Field
                                        name="email"
                                        component={TextFormField}
                                        label="E-mail Id "
                                        isRequired={true}
                                    />
                                </Grid2>


                                <Grid2 children size={{ sm: 6, xs: 12 }}>
                                    <Field
                                        name="pincode"
                                        component={TextFormField}
                                        label="Pin Code"
                                        isRequired={true}
                                        type={"number"}
                                    />
                                </Grid2>

                                <Grid2 children size={{ sm: 6, xs: 12 }}>
                                    <Field
                                        name="address"
                                        component={TextFormField}
                                        label="Address"
                                        isRequired={true}
                                    />
                                </Grid2>
                                <LocationSelectorField
                                    countryField="country_name"
                                    stateField="state"
                                    cityField="city"
                                    isStoredId={false}
                                    isPincode={false}
                                    Input_Width={{ xs: 12, sm: 6 }}
                                    userDetail={userDetail?.data}
                                    passedCityId={userDetail?.data?.city_id}
                                    passedStateId={userDetail?.data?.state_id}
                                    passedCountryId={userDetail?.data?.country_id}
                                />
                                <Grid2 children size={{ sm: 6, xs: 12 }} />
                                {/* <Grid2>
                                    <Button variant='contained' type="submit"> Save & Submit </Button>
                                </Grid2> */}

                            </Grid2>






                        </Form>
                    )}
                </Formik>
            </Box>


        </Box>
    )
}

export default ApartmentForm